import AuthGuard from '@components/AuthGuard';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import { IconProps } from '@models/icons';
import { JSX } from 'react';

interface Props {
    label: string;
    icon: (props: IconProps) => JSX.Element;
    onClick?: () =>void;
}

function SidebarButton({ label, icon: Icon, onClick }:Props) {
  return (
      <Column spacing={8} align='center' onClick={onClick}
              css={css`
                        border: 1px solid ${colors.gray2};
                        padding: 16px 0;
                        border-radius: 16px;
                    `} >
          <Icon size={24} color={colors.gray9}/>
          <Text color={colors.gray7} fontWeight='medium'>
              {label}
          </Text>
      </Column>
  );
}

export default SidebarButton;
